<template lang="pug">
    div
        div(v-for="error in errors" ) [ERROR] {{ error }}
        component(:is="selectedDemo" @init="onInit")
        loading-indicator(v-show="loading")
</template>

<script>
import TheDecodeAllDemo from '../components/TheDecodeAllDemo'
import LoadingIndicator from '../components/LoadingIndicator'
export default {
    name: "QrScan",
    components: {
        LoadingIndicator,
        TheDecodeAllDemo
    },
    data: () => ({
        selectedDemo: 'TheDecodeAllDemo',
        errors: [],
        loading: false
    }),
    watch: {
        'selectedDemo': 'clearErrors'
    },
    methods: {
        onDecode (result) {
            this.result = result;
        },
        async onInit (promise) {
            this.loading = true;
            try {
                await promise
                this.clearErrors()
            } catch (error) {
                this.openError(error)
            } finally {
                this.loading = false
            }
        },
        openError (error) {
            if (error.name === 'NotAllowedError') {
                this.errors.push('To detect and decode QR codes this page needs access to your camera')
            } else if (error.name === 'NotFoundError') {
                this.errors.push('Seems like you have no suitable camera on your device.')
            } else if (error.name === 'NotSupportedError') {
                this.errors.push('Seems like this page is served in non-secure context. Your browser doesn\'t support that')
            } else if (error.name === 'NotReadableError') {
                this.errors.push('Couldn\'t access your camera. Is it already in use?')
            } else if (error.name === 'OverconstrainedError') {
                this.errors.push('Constraints don\'t match any installed camera. Did you asked for the front camera although there is none?')
            } else {
                this.errors.push('UNKNOWN ERROR: ' + error.message)
                // console.error(error)
            }
        },
        closeError (error) {
            const index = this.errors.indexOf(error)
            this.errors.splice(index, 1)
        },
        clearErrors () {
            this.errors = []
        }
    }
}
</script>

